import React, { useCallback, useState } from 'react';
import { listComunidadGuardados, deleteComunidadGuardado } from '../../lib/comunidadGuardados.js';
import { Colors as C } from '../../constants/Colors.js';
import WebTopBar from '../components/WebTopBar.js';
import Icon from '../components/Icon.js';
import { DCard } from '../components/MarketplaceAtoms.js';
import { useAppDataLoad } from '../hooks/useAppDataLoad.js';

export default function PageComunidadGuardados({ onBack, onNavigate, user, onRequireAuth }) {
  const [removing, setRemoving] = useState({});

  const fetchGuardados = useCallback(async () => {
    if (!user?.id) return [];
    return listComunidadGuardados(user.id);
  }, [user?.id]);

  const {
    data: rowsRaw,
    loading,
    error: loadError,
    reload,
  } = useAppDataLoad(fetchGuardados, [user?.id], { enabled: !!user?.id, initialLoading: !!user?.id });
  const rows = rowsRaw ?? [];

  const quitar = async itemId => {
    if (!user?.id) return;
    setRemoving(r => ({ ...r, [itemId]: true }));
    await deleteComunidadGuardado(user.id, itemId);
    await reload();
    setRemoving(r => ({ ...r, [itemId]: false }));
  };

  if (!user) {
    return (
      <div style={{ background: C.dark, minHeight: '100vh', color: '#fff' }}>
        <WebTopBar onBack={onBack} title="Guardados" mini dark user={user} onNavigate={onNavigate} onShowModal={onRequireAuth ? t => onRequireAuth(t) : undefined} />
        <div style={{ maxWidth: 560, margin: '0 auto', padding: 40, textAlign: 'center' }}>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, marginBottom: 16 }}>Inicia sesión para ver tus eventos y lugares guardados en tu perfil.</p>
          {onRequireAuth ? (
            <button type="button" onClick={() => onRequireAuth('login')} style={{ background: C.gold, color: '#0a0a0f', border: 'none', padding: '10px 20px', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>Iniciar sesión</button>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: C.dark, minHeight: '100vh', color: '#fff' }}>
      <WebTopBar
        onBack={onBack}
        title="Guardados (Comunidad)"
        mini
        dark
        user={user}
        onNavigate={onNavigate}
        onSignOut={onBack}
      />
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '20px 18px 60px' }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', marginBottom: 16, lineHeight: 1.5 }}>
          Lugares, eventos, mercadillos y demás publicaciones de Comunidad que has guardado. Los datos se sincronizan con tu cuenta.
        </p>
        {loading ? (
          <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.35)', padding: 40 }}>Cargando…</div>
        ) : loadError ? (
          <div style={{ textAlign: 'center', color: 'rgba(255,180,180,0.9)', padding: 40, fontSize: 14 }}>
            {loadError}{' '}
            <button type="button" onClick={() => reload()} style={{ background: 'none', border: 'none', color: C.gold, textDecoration: 'underline', cursor: 'pointer' }}>
              Reintentar
            </button>
          </div>
        ) : rows.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px 16px', color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>
            Aún no has guardado nada. Ve a <button type="button" onClick={() => onNavigate('comunidad')} style={{ background: 'none', border: 'none', color: C.gold, textDecoration: 'underline', cursor: 'pointer' }}>Comunidad</button> y pulsa <strong>Guardar</strong> en una ficha.
          </div>
        ) : (
          rows.map(r => {
            const s = r.item_snapshot || {};
            return (
              <DCard key={r.id} style={{ padding: '12px 14px', marginBottom: 10, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: 48, height: 48, borderRadius: 8, flexShrink: 0, overflow: 'hidden',
                    background: s.color || 'rgba(200,168,75,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  {s.imagenUrl ? (
                    <img src={s.imagenUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <Icon name="map" size={20} color="rgba(255,255,255,0.4)" />
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>{s.title || 'Sin título'}</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginTop: 3 }}>{s.extraTipo || s.type || 'Comunidad'}</div>
                  {s.place ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>📍 {s.place}</div> : null}
                  {s.date ? <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>📅 {s.date}</div> : null}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
                  <button
                    type="button"
                    disabled={removing[r.item_id]}
                    onClick={() => onNavigate('comunidad')}
                    style={{ background: 'rgba(200,168,75,0.15)', border: `1px solid ${C.gold}`, color: C.gold, fontSize: 10, fontWeight: 600, padding: '6px 8px', borderRadius: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}
                  >Comunidad
                  </button>
                  <button
                    type="button"
                    disabled={removing[r.item_id]}
                    onClick={() => quitar(r.item_id)}
                    style={{ background: 'transparent', border: '1px solid rgba(226,75,74,0.35)', color: 'rgba(255,150,150,0.9)', fontSize: 10, padding: '6px 8px', borderRadius: 6, cursor: 'pointer' }}
                  >Quitar
                  </button>
                </div>
              </DCard>
            );
          })
        )}
      </div>
    </div>
  );
}
